import React from "react";
import { useTranslation } from "react-i18next";
import EnViaEmail from "../assets/images/EN_Question_Email.png";
import FrViaEmail from "../assets/images/FR_Question_Email.png";
import EnDiscordLoginButton from "../assets/images/EN_Question_Discord.png";
import FrDiscordLoginButton from "../assets/images/FR_Question_Discord.png";
import { useNavigate } from "react-router-dom";

interface Props {
  setShowResponseOptionModal: React.Dispatch<React.SetStateAction<boolean>>;
  onShowCommentForm: () => void;
}

export const ResponseOption: React.FC<Props> = ({
  setShowResponseOptionModal,
  onShowCommentForm,
}) => {
  const { t } = useTranslation();
  const language = t("localization_testing");
  const navigate = useNavigate();
  const DiscordLoginButtonPng =
    language === "fr" ? FrDiscordLoginButton : EnDiscordLoginButton;
  const ViaEmailPng = language === "fr" ? FrViaEmail : EnViaEmail;

  return (
    <div className="flex flex-col w-full pt-4 pl-1">
      <div className="flex flex-col justify-center items-center">
        <div className="text-slate-300 pt-1 text-sm space-x-1">
          <span>{t("FAQ.FAQPrompt1")}</span>
          <button
            className="text-blue-500 underline text-base hover:opacity-70 transition duration-200 ease-in-out"
            onClick={() => {
              navigate("/FAQ");
              setShowResponseOptionModal(false);
            }}
            type="button"
          >
            {"FAQ"}
          </button>
          <span>
            {t(",")} {t("form.forOtherQuestions")}
          </span>
        </div>
        <div className="text-slate-300 text-center pt-8 text-sm">
          {t("form.24hResponse")}
        </div>
        <a
          href="https://discord.gg/npWGrtvua6"
          draggable={false}
          target="_blank"
          rel="noreferrer"
          className="pt-2 hover:opacity-70 transition duration-200 ease-in-out"
        >
          <img
            src={DiscordLoginButtonPng}
            alt="Discord button"
            className="h-12"
          />
        </a>
        <div className="text-slate-300 text-center pt-8 text-sm">
          {t("form.48hResponse")}
        </div>
        <button
          className="pt-2 pb-2 hover:opacity-70 transition duration-200 ease-in-out"
          onClick={() => {
            onShowCommentForm();
          }}
          type="button"
        >
          <img src={ViaEmailPng} alt="Email button" className="h-12" />
        </button>
      </div>
    </div>
  );
};
